import { APIEndpoints } from "@/utils/APIEndpoints";
import { riccAPI } from "./APIService";

riccAPI.injectEndpoints({
  endpoints: (builder) => ({
    // Search product ownership
    searchProductOwnership: builder.mutation({
      query: (payload) => ({
        url: APIEndpoints.searchProductOwnership,
        method: "POST",
        body: payload,
        headers: {
          accessProfileId: payload.accessProfileId,
          productMfgId: payload.productSponsorId,
        },
      }),
    }),
    // Inquire Product Ownership
    inquireProductOwnership: builder.mutation({
      query: (payload) => ({
        url: APIEndpoints.inquireProductOwnership,
        method: "POST",
        body: payload,
        headers: {
          accessProfileId: payload.accessProfileId,
          productMfgId: payload.productSponsorId,
        },
      }),
    }),
    // Get Ownership Inquiry
    getOwnershipInquiry: builder.mutation({
      query: (payload) => ({
        url: APIEndpoints.getOwnershipInquiry,
        method: "POST",
        body: payload,
        headers: {
          accessProfileId: payload.accessProfileId,
          productMfgId: payload.productSponsorId,
        },
      }),
    }),
    // Get ownership money source details
    getOwnershipMoneySourceDetails: builder.mutation({
      query: (payload) => ({
        url: APIEndpoints.getOwnershipMoneySourceDetails,
        method: "POST",
        body: payload,
        headers: {
          accessProfileId: payload.accessProfileId,
          productMfgId: payload.productSponsorId,
        },
      }),
    }),
    getTransactionDetail: builder.mutation({
      query: (payload) => ({
        url: APIEndpoints.getTransactionDetail,
        method: "POST",
        body: payload,
        headers: {
          accessProfileId: payload.accessProfileId,
          productMfgId: payload.productSponsorId,
        },
      }),
    }),
    getWithdrawalInquiry: builder.mutation({
      query: (payload) => ({
        url: APIEndpoints.getWithdrawalInquiry,
        method: "POST",
        body: payload,
        headers: {
          accessProfileId: payload.accessProfileId,
          productMfgId: payload.productSponsorId,
        },
      }),
    }),
    saveWithdrawalElection: builder.mutation({
      query: (payload) => ({
        url: APIEndpoints.saveWithdrawalElection,
        method: "POST",
        body: payload,
        headers: {
          accessProfileId: payload.accessProfileId,
          productMfgId: payload.productSponsorId,
        },
      }),
    }),
    updateProductOwnershipJointAnnuitantTransaction: builder.mutation({
      query: (payload) => ({
        url: APIEndpoints.updateProductOwnershipJointAnnuitantTransaction,
        method: "PUT",
        body: payload,
        headers: {
          accessProfileId: payload.accessProfileId,
          productMfgId: payload.productSponsorId,
        },
      }),
    }),
    getProductOwnershipJointAnnuitant: builder.mutation({
      query: (payload) => ({
        url: APIEndpoints.getProductOwnershipJointAnnuitant,
        method: "POST",
        body: payload,
        headers: {
          accessProfileId: payload.accessProfileId,
          productMfgId: payload.productSponsorId,
        },
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useSearchProductOwnershipMutation,
  useInquireProductOwnershipMutation,
  useGetOwnershipInquiryMutation,
  useGetOwnershipMoneySourceDetailsMutation,
  useGetTransactionDetailMutation,
  useGetWithdrawalInquiryMutation,
  useSaveWithdrawalElectionMutation,
  useUpdateProductOwnershipJointAnnuitantTransactionMutation,
  useGetProductOwnershipJointAnnuitantMutation,
} = riccAPI;
